<template lang="pug">
extends ../../../prototype/src/pug/layout/section_column_gray_top
include ../../../prototype/src/pug/abstracts/mixin.pug
block main
	.duvidas_frequentes__wrapper
		h1.duvidas_frequentes__title Central de Documentação de Certificação Digital

		p.duvidas_frequentes__description Aqui te ajudamos a encontrar dados confiáveis e organizados para facilitar sua pesquisa. Nesta página disponibilizamos as Práticas e Políticas de uso do certificado digital, a Lista de Certificados Revogados e a Relação de Entidades Vinculadas às AC CNDL RFB.

		div('v-for'="item in questions")
			h2.duvidas_frequentes__subtitle('v-html'="item.topic", :id="normalize(item.topic)") xxx
			.duvidas_frequentes__questions
				QuestionRow('v-for'="subitem in item.data" :question="subitem.question" :answer="subitem.answer" :download="subitem.download" :view="subitem.view" :files="subitem.files" :download_2="subitem.download_2")
block variables
	- var id = 'repositorio'
</template>

<script>
import data from "@/assets/repositorio.json";
import QuestionRow from "@/components/duvidas_frequentes/question_row.vue";

export default {
	name: "Repositorio",
	components: {
		QuestionRow,
	},
	data: function () {
		return {
			questions: data,
		};
	},
	metaInfo: {
		title: "Perguntas Frequentes Sobre Certificado Digital - SPC Brasil",
		meta: [
			{
				description:
					"Tire todas as suas dúvidas sobre o uso e a instalação de um certificado digital - tanto eCPF quanto eCNPJ. Acesse agora!",
			},
		],
	},
	methods: {
		normalize: function (text) {
			return text
				.toLowerCase()
				.replace(/ /gi, "-")
				.replace(/&/gi, "")
				.replace(/\(/gi, "")
				.replace(/\)/gi, "")
				.normalize("NFD")
				.replace(/[\u0300-\u036f]/g, "")
				.replace(/\?/gi, "")
				.replace(/:/gi, "");
		},
	},
};
</script>
